// Who can reach the ID credit application is decided by the backend alone: auth.php
// sets `showIdCreditApplication`. Opening or closing it is therefore an auth.php edit,
// with no frontend rebuild involved.

// True regardless of whether they already have ID credit. Existing customers get the
// invoices page at /idcredit, so this is also what lets them open the application page
// with ?idcreditPreview=1.
export const isIdCreditApplicationEnabled = (login) =>
    !!(login && login.privateClientData && login.privateClientData.showIdCreditApplication === '1');

// Authoritative "already an ID credit customer" status. Same flag the app uses to
// gate the /idcredit menu (NavBar.js), derived from the backend — not a heuristic on
// card names.
export const isIdCreditCustomer = (login) =>
    !!(login && login.currentRole && login.currentRole.isIdCredit === '1');

// Show the application page to anyone who is not an ID credit customer yet.
export const shouldShowIdCreditApplication = (login) =>
    isIdCreditApplicationEnabled(login) && !isIdCreditCustomer(login);

// Whether the ?idcreditPreview=1 escape hatch is present in a query string.
// Case-insensitive on purpose: the link gets shared by hand and query parameter names
// are case-sensitive, so a lowercased copy would silently do nothing.
export const isPreviewRequested = (search) => {
    const params = new URLSearchParams(search || '');

    for (const [name, value] of params.entries()) {
        if (name.toLowerCase() === 'idcreditpreview' && value === '1') {
            return true;
        }
    }

    return false;
};
